import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
import INST from "../../assets/images/socail/instagram.svg";
import FAB from "../../assets/images/socail/facebook.svg";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FlodeskForm from "../../components/flodeskBlog";
const NewsRoomDetails = () => {
  const url = useLocation();
  const queryParams = new URLSearchParams(url.search);
  const id = queryParams.get("id");
  const [newsData, setNewsData] = useState();
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND + `news-room/getnews?newsid=${id}`)
      .then((resp) => {
        setNewsData(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const fullUrl = window.location.href;
  const openUrl = (url) => {
    window.open(url, "_blank");
  };
  return (
    <div className="container my-5 " style={{ width: "auto" }}>
      <div className="row px-2">
        <div className="col-md-9 col-sm-12">
          <h1>{newsData?.title}</h1>
          <div>
            <img
              src={newsData?.image}
              alt="no image"
              className="mt-3 imgclass"
              style={{ borderRadius: "6px", height: "auto" }}
            />
          </div>
          {newsData?.publishedAt !== undefined && (
            <div className="d-flex align-items-center mt-2">
              <CalendarMonthIcon
                className="me-1"
                style={{ color: "var(--primary-color)" }}
              />{" "}
              {format(new Date(newsData?.publishedAt), "MMM dd , yyyy")}
            </div>
          )}
          <div
            dangerouslySetInnerHTML={{
              __html: newsData?.content, // Inject raw HTML content
            }}
            className="ms-2 py-2 mt-3"
          />
        </div>
        <div className="col-md-3 col-sm-12 ">
          <h3 className="mt-3">Share with Friends</h3>
          <div
            style={{
              background: "var(--primary-color)",
              height: "2px",
              width: "10%",
            }}
          ></div>
          <div
            className="d-flex align-items-center justify-content-start mt-3 "
            style={{ gap: 10 }}
          >
            <img
              src={INST}
              className="c-pointer"
              onClick={() => openUrl(`https://www.instagram.com/`)}
            />{" "}
            <img
              src={FAB}
              style={{ width: "9%" }}
              className="c-pointer"
              onClick={() =>
                openUrl(
                  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                    fullUrl
                  )}`
                )
              }
            />
          </div>
          {newsData?.tags.length !== 0 && (
            <>
              <h3 className="mt-5">Tags</h3>
              <div
                style={{
                  background: "var(--primary-color)",
                  height: "2px",
                  width: "10%",
                }}
              ></div>

              <div className="mt-3 bxShadow px-2 py-3">
                {newsData?.tags.map((tg, index) => (
                  <p
                    className="fs-8"
                    key={index}
                    style={{
                      background: "var(--pile-green)",
                      width: "fit-content",
                      padding: "2px 10px",
                      borderRadius: "6px",
                    }}
                  >
                    {tg}
                  </p>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      {newsData?.flodeskId && <FlodeskForm id={newsData?.flodeskId} />}
    </div>
  );
};

export default NewsRoomDetails;
